import React, { useEffect } from "react";
import { topSongsData } from "./topSongsData";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import {
  playNewSong,
  setplay,
  setloaded,
  setcurrentSongIndex,
  setcurrentSongList,
} from "../../../redux/actions/player";
import MusicBars from "../../../components/animation/MusicBars";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { setselectedAddPlaylist } from "../../../redux/actions/music";
import { mainPlayerToggle } from "../../../redux/actions/styles";
import TooltipPrimary from "../../../components/tooltips/TooltipPrimary";

const TopSongs = () => {
  const dispatch = useDispatch();
  const AC = bindActionCreators({ playNewSong, setloaded, setplay }, dispatch);

  const { currentSong, play, currentSongIndex } = useSelector((state) => state.player);

  function onClickPlay(song, index) {
    dispatch(playNewSong(song));
    dispatch(setplay(true));
    dispatch(setcurrentSongIndex(index));
    dispatch(setcurrentSongList(topSongsData));
  }

  return (
    <div className="top-songs">
      <div className="header">
        <h3>Top Songs</h3>
        <p>See All</p>
      </div>
      <div className="songs">
        {topSongsData.map((item, index) => (
          <div key={item.name + item.artist} className="card">
            <img src={item.img} alt="justin bieber" />
            <div className="details">
              <h3>{item.name}</h3>
              <p>{item.artist}</p>
            </div>
            <div className="actions">
              {play && currentSong.name === item.name ? <MusicBars /> : <p className="time">{item.duration}</p>}
              {play && currentSong.name === item.name ? (
                <TooltipPrimary text="Pause" className="icon pause-btn" onClick={() => AC.setplay(false)}>
                  <PauseRoundedIcon />
                </TooltipPrimary>
              ) : (
                <TooltipPrimary text="Play" className="icon play-btn" onClick={() => onClickPlay(item, index)}>
                  <PlayArrowRoundedIcon />
                </TooltipPrimary>
              )}
              <TooltipPrimary
                text="Add to playlist"
                className="icon playlist-add"
                onClick={() => dispatch(setselectedAddPlaylist(item))}
              >
                <PlaylistAddIcon />
              </TooltipPrimary>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopSongs;
